module.exports = __webpack_public_path__ + "img/attnet.057d7765.png";